module.exports = __webpack_public_path__ + "static/media/sorentofwd2015.d76d5c4e.webp";